<template>
    <div class="checkbox-group clearfix" :class="{block:size !=='default'}">
        <label class="checkbox"  
               
              v-for="option in options" 
              :key="option[bindValue]">

            <input
                    type="checkbox"
                    :name="inputName"
                    :value="option[bindValue]"
                    v-model="checkValues"
                    @click="onClickCheckox(option,$event)"
                >
            <i></i>
            {{option[displayName]}}
        </label>
    </div>
</template>
<script>
export default {
  name: "checkbox-group",
  props: {
    options: {
      type: Array,
      required: true
    },
    bindValue: {
      type: String,
      required: false,
      default: "Id"
    },
    displayName: {
      type: String,
      required: false,
      default: "Name"
    }, 
    values: {
      type: Array,
      required: false,
      default: []
    },
    /**
     * 排它值，当点到这个值的时候，就将其他的值都设为false
     */
    exclusive: {
      type: String,
      required: false,
      default: null
    },
    /**
     * 排它的文本，当点到这个选项时，就将其他的值都设为false，与exclusive共用
     * 有任何一个条件满足时，即将其他的值设为false
     */
    exclusiveText: {
      type: String,
      required: false,
      default: null
    },
    name: {
      type: String,
      required: false
    },
    size:{ // allow values: default | 100
      type:String,
      required:false,
      default:'default'
    }
  },
  model: {
    event: "check-change",
    prop: "values"
  },
  data() {
    return {
      checkValues: [],
      inputName: "",
      valueDictonary: {}
    };
  },
  created() {
    this.checkValues = this.values;
    if (this.name) {
      this.inputName = this.name;
    } else {
      this.inputName = "chk_" + parseInt(Math.random() * 23423452).toString();
    }
    this.updateDictionary(this.options);
    
  },
  watch: {
    options: function(newOptions, oldOptions){
      this.updateDictionary(newOptions);
    },
    values: function(newValues,oldValues){
      this.checkValues = newValues;
    }
  },
  methods: {
    onClickCheckox(option,event) {
      setTimeout(() => {
        this.updateCheckValue(option,event);
      }, 50);
    },
    updateDictionary(newOptions) {
      var dic = {};
      if (newOptions && newOptions.length > 0) {
        for (let i = 0; i < newOptions.length; i++) {
          let item = newOptions[i];
          dic[item[this.bindValue]] = item[this.displayName].trim();
        }
      }
      this.valueDictonary = dic;
    },
    updateCheckValue(option,event) {
      if (!this.exclusive && !this.exclusiveText) {
        this.$emit("check-change", this.checkValues);
        return;
      }

      if (
        option[this.bindValue] === this.exclusive ||
        option[this.displayName].trim() === this.exclusiveText
      ) {
        if(event.target.checked){
          // 当点击的值，正好是这个排它值的时候，只取它一个值
          this.checkValues = [option[this.bindValue]];
        } else {
          this.checkValues = [];
        }
        
      } else {
        // 当点击的非排它值的时候，将排它值忽略掉
        var newValues = [];
        for (let i = 0; i < this.checkValues.length; i++) {
          let current = this.checkValues[i];
          if (
            current !== this.exclusive &&
            this.valueDictonary[current] !== this.exclusiveText
          ) {
            newValues.push(current);
          }
        }
        this.checkValues = newValues;
      }
      this.$emit("check-change", this.checkValues);
    }
  }
};
</script>
<style lang="less">
.checkbox-group {
      display: block;
      margin-top: 15 / @rem-size;

       
    }
</style>


